<template>
<div>
  <div class="add-tier" @click="showDialog = true">+</div>
  <div v-if="showDialog" class="dialog-tier">
    <div class="container-message">
      <h3>Confirmación</h3>
      <div class="text">Se va a agregar <span class="dark">1 producto <span class="uppercase">{{ nameProduct }}</span></span> al nivel <span class="dark">{{ tier }}</span> en la talla <span class="dark">{{ size }}</span> ¿Deseas continuar?</div>
      <div class="buttons">
          <shActionButton :action="close" text="No" textRunning="No" :principalColor="true"></shActionButton>
          <shActionButton :action="accept" text="Sí" textRunning="Sí"></shActionButton>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import mForm from '@/mixins/form'
import gqlStock from '@/graphql/stock'
import modals from '@my/store/modals'
import gql from '@my/graphql'

export default {
  name: 'AddTier',

  props: {
    nameProduct: { type: String, required: true },
    tier: { type: String, required: true },
    size: { type: String, required: true }
  },

  data () {
    return {
      showDialog: false
    }
  },

  mixins: [mForm],

  methods: {
    async accept () {
      const mutation = gqlStock.ADD_TO_TIER

      if (!this.nameProduct || !this.size || !this.tier) return

      const response = await gql.mutate(mutation, { reference: this.nameProduct, tier: this.tier, size: this.size })

      if (response && response.data && response.data.addToTier) {
        modals.showMessage({ message: `Se ha agregado un producto ${this.nameProduct} al nivel ${this.tier} en la talla ${this.size}` })
        this.$emit('added')
      }

      this.showDialog = false
    },

    close () {
      this.showDialog = false
    }
  }
}
</script>

<style>
.add-tier {
  background-color: #f6f6f6;
  position: absolute;
  height: 1.5em;
  width: 1.5em;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  top: -.5rem;
  right: -.5rem;
  cursor: pointer;
  border: 1px solid #c8c8c8;
  z-index: 50;
  color: #000000;
}

.add-tier:hover {
  background-color: #4CAF50;
  color: #fff;
}

.dialog-tier {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .4);
  z-index: 200;
  display: flex;
  justify-content: center;
  align-items: center;
}

.container-message {
  background-color: var(--background-principal);
  padding: 2em 3em;
  width: 100%;
  max-width: 40em;
  border-radius: 1.5em;
  color: #000000;
}
.container-message .text {
  margin: 0.5em 0 1em 0;
  font-size: 1.1em;
}
.container-message .buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1em;
}

</style>



// WEBPACK FOOTER //
// src/components/ecommerce/AddTier.vue